import { useCallback, useState } from 'react';

const skipNullItems = <T>(item: T) => item != null;

const useDac7ArrayItems = <T extends object>(
  initialItems: ReadonlyArray<T & { feId?: string }> | undefined,
) => {
  const [items, setItems] = useState(initialItems?.filter(skipNullItems) ?? []);

  const addItem = useCallback((item: T) => {
    const decoratedItem = { ...item, feId: String(new Date().getTime()) };
    setItems(oldItems => [...oldItems, decoratedItem]);
  }, []);

  const removeItem = useCallback((i: number) => {
    setItems(oldItems => [...oldItems.slice(0, i), ...oldItems.slice(i + 1)]);
  }, []);

  return {
    items,
    addItem,
    removeItem,
  };
};

export default useDac7ArrayItems;
